<template>
    <div>
        <CCol sm="12">
            <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left" @click="GoToSettingProfile()"/>
            <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
        </CCol>
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
    
    <CCard class="p-2" style="border:none;">
        <CRow class="m-2">
            <CCol sm="12" md="4" lg="3" class="text-center p-2" v-for="button in buttons" :key="button.value">
                <div :class="{'blue-background': activeButton === button.value, 'blue-text': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                    <img style="max-width:20px" class="mr-2" /> {{ button.label }}
                </div>
            </CCol>

        </CRow>
    </CCard>
    <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div v-if="activeButton === 'BankDetail'">
                        <div>
                            <div class="p-2">
                                <CRow>
                                    <CCol sm="10">
                                        <h3 class="custom-18px-500 font-color-171717">Bank Detail</h3>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="12">
                                        <CRow>
                                            <CCol sm="12">
                                                <h3 class="custom-14px-500 font-color-171717">Bank</h3>
                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                            </CCol>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Account Number</h3>
                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                            </CCol>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Account Type</h3>
                                                <CInput type="text" v-model="detailStaff.PositionName" disabled/>
                                            </CCol>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Branch</h3>
                                                <CInput type="text" v-model="detailStaff.RegistrationNumber" disabled/>
                                            </CCol>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Account Status</h3>
                                                <CInput type="date" v-model="detailStaff.DateJoinCompany" disabled/>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>
            
                            </div>
                        </div>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                Edit</CButton>
                        </div>
                    </div>


                    <div v-if="activeButton === 'StatutoryDetail'">
                        <div>
                            <div class="p-2">
                                <CRow>
                                    <CCol sm="10">
                                        <h3 class="custom-18px-500 font-color-171717">Employee Provident Fund (EPF)</h3>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="12">
                                        <CRow>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">EPF Number</h3>
                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                            </CCol>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">EPF Contribution Start Date</h3>
                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="10">
                                        <h3 class="custom-18px-500 font-color-171717">Social Security Organization (SOCSO)</h3>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="12">
                                        <CRow>
                                            <CCol sm="4">
                                                <h3 class="custom-14px-500 font-color-171717">SOCSO Number</h3>
                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                            </CCol>
                                            <CCol sm="4">
                                                <h3 class="custom-14px-500 font-color-171717">SOCSO Contribution Start Age</h3>
                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                            </CCol>
                                            <CCol sm="4">
                                                <h3 class="custom-14px-500 font-color-171717">SOCSO Category</h3>
                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                            </CCol>
                                            <CCol sm="12">
                                                <h3 class="custom-14px-500 font-color-171717">Contribution Rate</h3>
                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>
            
                            </div>
                        </div>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                Edit</CButton>
                        </div>
                    </div>

                    <div v-if="activeButton === 'IncomeTax'">
                        <div>
                            <div class="p-2">
                                <CRow>
                                    <CCol sm="10">
                                        <h3 class="custom-18px-500 font-color-171717">Income Tax</h3>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="12">
                                        <CRow>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Income Tax Number</h3>
                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                            </CCol>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Value of Living Accommodation (VOLA)</h3>
                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>
            
                            </div>
                        </div>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                Edit</CButton>
                        </div>
                    </div>

                    <div v-if="activeButton === 'IncomeTaxDetail'">
                        <div>
                            <div class="p-2">
                                <CRow>
                                    <CCol sm="10">
                                        <h3 class="custom-18px-500 font-color-171717">Income Tax Detail</h3>
                                    </CCol>
                                    <CCol sm="12" md="4" lg="3" class="text-center p-2" v-for="button in buttonsTax" :key="button.value">
                                        <div :class="{'blue-background': activeButtonTax === button.value, 'blue-text': activeButtonTax !== button.value}" @click="setActiveButtonTax(button.value)" class="p-2">
                                            <img style="max-width:20px" class="mr-2" /> {{ button.label }}
                                        </div>
                                    </CCol>
                                </CRow>
                                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                                    <div v-if="activeButtonTax === 'ChildrenInfo'">
                                        <div>
                                            <div class="p-2">
                                                <CRow>
                                                    <CCol sm="12">
                                                        <CRow>
                                                            <CCol sm="12">
                                                                <h3 class="custom-14px-500 font-color-171717">Employee has Child<CSwitch class="ml-3" size="sm" style="margin-top: 6px;" shape="pill" color="primary" data-on="On" data-off="Off" checked/></h3>
                                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                                            </CCol>
                                                            <CCol sm="6">
                                                                <h3 class="custom-14px-500 font-color-171717">Under the age of 18 years</h3>
                                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                                            </CCol>
                                                            <CCol sm="6">
                                                                <h3 class="custom-14px-500 font-color-171717">18 Years & above and studying (Included Certificate/Metriculation)</h3>
                                                                <CInput type="text" v-model="detailStaff.PositionName" disabled/>
                                                            </CCol>
                                                            <CCol sm="6">
                                                                <h3 class="custom-14px-500 font-color-171717">Above 18 years and studying full time in diploma level onwards (Malaysia) or Degree level onwards (outside Malaysia):</h3>
                                                                <CInput type="text" v-model="detailStaff.RegistrationNumber" disabled/>
                                                            </CCol>
                                                            <CCol sm="6">
                                                                <h3 class="custom-14px-500 font-color-171717">Disabled child studying in diploma or higher level (in Malaysia)/degree or its equivalent (outside Malaysia)</h3>
                                                                <CInput type="text" v-model="detailStaff.DateJoinCompany" disabled/>
                                                            </CCol>
                                                            <CCol sm="6">
                                                                <h3 class="custom-14px-500 font-color-171717">Disable Child</h3>
                                                                <CInput type="text" v-model="detailStaff.DateJoinCompany" disabled/>
                                                            </CCol>
                                                        </CRow>
                                                    </CCol>
                                                </CRow>
                            
                                            </div>
                                        </div>
                                        <div class="text-right">
                                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                                Edit</CButton>
                                        </div>
                                    </div>


                                    <div v-if="activeButtonTax === 'SpouseInfo'">
                                        <div>
                                            <div class="p-2">
                                                <CRow>
                                                    <CCol sm="12">
                                                        <CRow>
                                                            <CCol sm="6">
                                                                <h3 class="custom-14px-500 font-color-171717">Spouse is Working<CSwitch class="ml-3" size="sm" style="margin-top: 6px;" shape="pill" color="primary" data-on="On" data-off="Off" checked/></h3>
                                                            </CCol>
                                                            <CCol sm="6">
                                                                <h3 class="custom-14px-500 font-color-171717">Spouse is Disables<CSwitch class="ml-3" size="sm" style="margin-top: 6px;" shape="pill" color="primary" data-on="On" data-off="Off" checked/></h3>
                                                            </CCol>
                                                            <CCol sm="6">
                                                                <h3 class="custom-14px-500 font-color-171717">Spouse Gender</h3>
                                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                                            </CCol>
                                                        </CRow>
                                                    </CCol>
                                                </CRow>
                            
                                            </div>
                                        </div>
                                        <div class="text-right">
                                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                                Edit</CButton>
                                        </div>
                                    </div>

                                    <div v-if="activeButtonTax === 'ReliefInfo'">
                                        <div>
                                            <div class="p-2">
                                                <CRow>
                                                    <CCol sm="12">
                                                        <CRow>
                                                            <CCol sm="12">
                                                                <h3 class="custom-14px-500 font-color-171717">Contribution to Social Security Organizations (SOCSO) including contributions to the Employment Insurance System (SIP)<CSwitch class="ml-3" size="sm" style="margin-top: 6px;" shape="pill" color="primary" data-on="On" data-off="Off" checked/></h3>
                                                                
                                                            </CCol>
                                                        </CRow>
                                                    </CCol>
                                                </CRow>
                            
                                            </div>
                                        </div>
                                        <div class="text-right">
                                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                                Edit</CButton>
                                        </div>
                                    </div>

                                    <div v-if="activeButtonTax === 'EmployeeCategory'">
                                        <div>
                                            <div class="p-2">
                                                <CRow>
                                                    <CCol sm="12">
                                                        <CRow>
                                                            <CCol sm="12">
                                                                <h3 class="custom-14px-500 font-color-171717">Determine whether employee is Returning Expert Programme (REP), Knowledge Worker at Specific Region (Iskandar Malaysia) or neither</h3>
                                                                <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                                            </CCol>
                                                        </CRow>
                                                    </CCol>
                                                </CRow>
                            
                                            </div>
                                        </div>
                                        <div class="text-right">
                                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                                Edit</CButton>
                                        </div>
                                    </div>

                                    
                    

                                </CCard>
            
                            </div>
                        </div>
                    </div>
       

                </CCard>
            </CCol>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            user: {},
            detailStaff: {},
            activeButton: 'BankDetail', // Default active button
            buttons: [
                { value: 'BankDetail', label: 'Bank Detail'},
                { value: 'StatutoryDetail', label: 'Statutory Detail'},
                { value: 'IncomeTax', label: 'Income Tax'},
                { value: 'IncomeTaxDetail', label: 'Income Tax Detail'},
            ],
            activeButtonTax: 'ChildrenInfo', // Default active button
            buttonsTax: [
                { value: 'ChildrenInfo', label: 'Children Information'},
                { value: 'SpouseInfo', label: 'Spouse Information'},
                { value: 'ReliefInfo', label: 'Relief Information'},
                { value: 'EmployeeCategory', label: 'Employee Category'},
            ],
            options: {
                perPage: 5,
                pagination: true,
                searchable: true
            },

        }





    },
    async mounted() {
        await this.GetListDetailStaff();
        await this.GetInfoUser();

    },

    computed: {

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        async GetListDetailStaff(id) {
            try {
                console.log("id" + id);
                const response = await this.$API.get(this.$GetStaffDetails + "?id=" + this.$route.query.id, {
                    withCredentials: true,
                });
                if (response.status === 200) {

                    this.detailStaff = response.data;

                } else {
                    console.error("Failed to fetch information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        async GoToSettingProfile(pageName = "SettingProfile") {
            let id = this.$route.query.id; // Retrieve the `id` from the current route

            if (!id) {
                console.warn("ID is missing in the query parameters!");

                // Fetch the user ID using GetInfoUser method
                try {
                    await this.GetInfoUser(); // Call GetInfoUser to populate `this.user`
                    id = this.user?.id; // Assume `this.user` contains `id` after fetching

                    if (!id) {
                        console.error("Unable to retrieve user ID from user information.");
                        alert("An error occurred. Please log in again.");
                        return this.$router.push({ path: "/Login" }); // Redirect to login if ID is missing
                    }
                } catch (error) {
                    console.error("Error retrieving user ID:", error);
                    alert("An error occurred. Please log in again.");
                    return this.$router.push({ path: "/Login" });
                }
            }

            // Navigate to the specified page with the resolved `id` as query parameter
            this.$router.push({ name: pageName, query: { id } });
        },
        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        setActiveButtonTax(buttonValue) {
            this.activeButtonTax = buttonValue;
        },


    }

};
</script>